__turbopack_context__.v({
  "root": "GlobalClubsLeaderboard-module-scss-module__l-j-xa__root",
  "toolbar": "GlobalClubsLeaderboard-module-scss-module__l-j-xa__toolbar",
});
